import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiCheck, FiExternalLink } from '../common/Icons';
import SafeIcon from '../common/SafeIcon';
import { resultsData } from '../data/results';

const ResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { resultKey, name, phone } = location.state || {};

  useEffect(() => {
    // Se non ci sono dati (accesso diretto all'URL), torna alla home
    if (!resultKey) {
      navigate('/');
    }
    
    // Scroll in alto all'apertura
    window.scrollTo(0, 0);
  }, [resultKey, navigate]);

  if (!resultKey) return null;

  const data = resultsData[resultKey];

  return (
    <div className="min-h-screen bg-black-pure py-12 px-6 flex items-center justify-center relative overflow-hidden font-sans">
      <div className="absolute inset-0 bg-orange-500/5 blur-[120px] pointer-events-none"></div>
      
      <motion.div 
        initial={{ opacity: 0, scale: 0.9, y: 20 }} 
        animate={{ opacity: 1, scale: 1, y: 0 }} 
        className="bg-slate-900/40 border border-white/10 rounded-[2.5rem] p-8 md:p-12 max-w-2xl w-full text-center relative z-10 backdrop-blur-2xl shadow-2xl"
      >
        <motion.div 
          initial={{ scale: 0 }} 
          animate={{ scale: 1 }} 
          transition={{ type: "spring", damping: 12, delay: 0.2 }}
          className={`w-24 h-24 bg-gradient-to-br ${data.color} rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-orange-500/20`}
        >
          <SafeIcon icon={FiCheck} className="text-white text-5xl" />
        </motion.div>

        <h2 className="text-sm font-black text-orange-500 uppercase tracking-[0.3em] mb-4 italic text-center">
          Analisi Completata per {name}
        </h2>
        
        <h1 className="text-3xl md:text-5xl font-black text-white mb-8 uppercase tracking-tighter leading-none">
          {data.title}
        </h1>

        <div className="bg-white/5 border border-white/5 rounded-3xl p-8 mb-10 text-left relative overflow-hidden">
          <div className={`absolute top-0 left-0 w-1 h-full bg-gradient-to-b ${data.color}`}></div>
          <p className="text-slate-300 text-lg md:text-xl font-medium leading-relaxed italic">
            “{data.desc}”
          </p>
        </div>

        <motion.a 
          whileHover={{ scale: 1.02 }} 
          whileTap={{ scale: 0.98 }} 
          href={data.link}
          target="_blank" 
          rel="noopener noreferrer"
          className="btn-premium w-full py-6 rounded-2xl font-black text-white text-xl flex items-center justify-center space-x-4 shadow-[0_20px_50px_rgba(249,115,22,0.3)] mb-12 group"
        >
          <span>{data.buttonText}</span>
          <SafeIcon icon={FiExternalLink} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
        </motion.a>

        <p className="text-slate-500 text-xs font-bold uppercase tracking-widest italic pt-6 border-t border-white/5">
          Riceverai ulteriori dettagli al numero: {phone}
        </p>

        <button 
          onClick={() => navigate('/')} 
          className="mt-8 text-slate-600 hover:text-white text-[10px] font-black uppercase tracking-widest transition-colors"
        >
          Torna alla Home
        </button>
      </motion.div>
    </div>
  );
};

export default ResultPage;